import { formattedDatePtBrToIso } from '@utils/dates/formattedDatePtBrToIso'
import { unMaskCurrency } from '@utils/masks/unMaskCurrency'

import type { AddEditOtherConsumptionRequestProps } from '@services/api/consumption/types'
import type { AddEditOtherConsumptionsModalFormProps } from '../components/modals/AddEditOtherConsumptions/form/types'

export const parseAddEditOtherConsumption = (formData: AddEditOtherConsumptionsModalFormProps) => {
  const payload: AddEditOtherConsumptionRequestProps = {
    competenceDate: formData.competenceDate || '',
    consumptionTypeId: Number(formData.launch) || 0,
    date: formData.date ? formattedDatePtBrToIso(formData.date) : '',
    filiCode: formData.filiCode || '',
    id: formData.id || null,
    observations: formData.observations || '',
    totalValue: formData.totalValue ? unMaskCurrency(formData.totalValue) : null
  }

  return payload
}
